<template>
<div class="notifications">
  <v-card>
    <v-toolbar flat dense dark color="primary">
      <v-toolbar-title>Powiadomienia</v-toolbar-title>
    </v-toolbar>
    <v-layout row wrap>
      <v-flex>
        <notifications-settings :user="authUser" @push-status="enablePush = $event"></notifications-settings>
      </v-flex>
      <v-flex>
        <notifications-push-init class="mt-2" v-if="enablePush"></notifications-push-init>
      </v-flex>
    </v-layout>
  </v-card>
  <v-layout justify-center row class="mt-5">
    <v-flex sm8>
      <v-card>
          <v-data-iterator
            :items="notificationsList"
            :pagination.sync="context"
            :rows-per-page-items="perPageOptions"
            :total-items="rowsTotal"
            :loading="loading"
            content-tag="v-list"
            :content-props="{twoLine: true}"

          >
            <template slot="item" slot-scope="props" >
              <v-list-tile @click="goToData(props.item)">
                <v-layout justify-space-between row wrap>
                  <v-flex xs12 md8 class="d-inline-block notification-text">
                    {{ props.item.message }}
                  </v-flex>
                  <v-flex xs12 md4 class="text-md-right d-inline-block">
                    <v-list-tile-action-text>{{ props.item.created_at | formatDate('LLL') }}</v-list-tile-action-text>
                  </v-flex>
                </v-layout>
              </v-list-tile>
              <v-divider />
            </template>
          </v-data-iterator>
      </v-card>
    </v-flex>
  </v-layout>
</div>
</template>

<script>
import {fetchNotifications, readAll} from './api'
import {ListMixin} from '@/utils/ListMixin'
import { mapGetters } from 'vuex'
import _ from 'lodash'
import NotificationsSettings from './NotificationsSettings'
import NotificationsPushInit from './NotificationsPushInit'

export default {
  components: {NotificationsSettings, NotificationsPushInit},
  mixins: [ListMixin],
  data () {
    return {
      notificationsList: [],
      enablePush: false
    }
  },
  computed: {
    ...mapGetters(['authUser'])
  },
  created () {
    this.fetchNotificationsList()
  },
  watch: {
    '$route': 'fetchNotificationsList',
    context: {
      handler () {
        this.fetchNotificationsList()
      },
      deep: true
    }
  },
  methods: {
    refresh: _.debounce(function () {
      this.fetchNotificationsList()
    }, 400),
    goToData (item) {
      if (item && item.data && item.data.url) {
        console.log(item.data.url)
        this.$router.push(item.data.url)
      }
    },
    fetchNotificationsList () {
      this.loading = true
      let params = this.prepareParams()
      let promise = fetchNotifications(this.authUser, params)
      return promise.then(this.enhanceListData).then((data) => {
        readAll()
        this.loading = false
        this.notificationsList = data
      })
    }
  }
}
</script>
<style>
.notification-text {
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/notifications/Notifications.vue